<div *ngIf="showToast" class="toast-container">
    <div [ngClass]="['toast-message', toastType === 'success' ? 'toast-success' : 'toast-error']">
        <div class="toast-content">
            <div class="toast-text">
                <div class="toast-title">{{ toastTitle }}</div>
                <div class="toast-message-text">{{ toastMessageText }}</div>
            </div>
            <span class="material-symbols-outlined f-24 cursor-pointer" 
                id="registration_expired_toast_close"
                tabindex="0"
                (click)="closeToast()" 
                (keypress)="closeToast()"
                title="Close">close</span>
        </div>
    </div>
</div>
<div class="bg-white custom-hv">
    <div class="container">
        <div class="row justify-content-center mt-4">
            <div class="col-lg-12 col-md-12 col-sm-12 d-flex justify-content-center">
                <img src="assets/images/edu-logo.svg" alt="NDE logo" class="img-fluid" />
            </div>
        </div>
        <hr />
        <div class="link-container">
            <div class="link-card">

                <div class="row justify-content-center">
                    <div>
                        <img src="assets/images/expired.svg" alt="link expired" class="img-fluid" />
                    </div>
                </div>
                <div class="row justify-content-center mt-4">
                    <div *ngIf="cdStatus === 'completed'">
                        <h1 id="registration_heading" class="text-center">Registration Completed</h1>
                        <p class="text-black text-center mt-3">
                            Your registration has already been completed. Please log in using your registered email address to access your account.
                        </p>
                    </div>
                    <div *ngIf="cdStatus !== 'completed' && purged">
                        <h1 id="registration_heading" class="text-center">Registration Link Expired</h1>
                        <p class="text-black text-center mt-3">
                            Your registration link has expired, and your registration details have been removed from our
                            system
                            for security reasons. Please start a new registration to create your account.
                        </p>
                    </div>
                    <div *ngIf="cdStatus !== 'completed' && !purged">
                        <h1 id="registration_heading" class="text-center">Registration Link Expired</h1>
                        <p id="p_registration_maskemail" class="text-black text-center mt-2 mb-0"><strong>Email:</strong> {{maskedEmail}}</p>
                        <p class="text-black text-center mt-2">
                            The link you used has expired. Registration links are valid for 24 hours for security reasons.
                            You can request a new link to complete your registration.
                        </p>
                    </div>
                    <div class="d-flex btn-container justify-content-between mt-3">
                        <button *ngIf="cdStatus !== 'completed'" type="button" id="btn-registration-expired-cancel" class="btn btn-outline-secondary mr-2" routerLink="/login">Cancel</button>
                        <button *ngIf="cdStatus === 'completed'" type="button" id="btn-registration-expired-login" class="btn btn-primary" (click)="navigateToLogin()">Login</button>
                        <button *ngIf="cdStatus !== 'completed' && !purged" type="button" id="btn-registration-expired-request-new-link" class="btn btn-primary" (click)="newRequest()">Request New Link</button>   
                        <button *ngIf="cdStatus !== 'completed' && purged" type="button" id="btn-registration-expired-start-new-registration" class="btn btn-primary" routerLink="/reg-form">Start New Registration</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>